/**
 * The Name of the Module
 */
 const moduleName = 'Buttons';

/**
 * Class default values
 */
 const defaults = {
  selectors: ['.button'],
  onlyOneActive: false,
  classSuffix: '-active'
};

/**
 * class Buttons Module
 */
 class Buttons {

 /**
  * constructor of Buttons Class
  */
  constructor(options) {
    this._prepare(options);
  }

 /**
  * prepare Function
  * Extend Default, Save Selectors, EventHandlers
  */
  _prepare(options) {
    const self = this;

    // Extend default options
    self.options = $.extend(true, defaults, options);
    self.$html = $('html');

    // Save selectors ECMS 5 (iE9)
    self.options.selectors.forEach((i) => {
      self.selectors = self.selectors ? self.selectors.add(i) : $(i);
    });

    // Set the Click event on the selectors
    self.selectors.on(`click.${moduleName}`, (event) => {
      event.preventDefault();
      const $this = $(event.currentTarget);

      if ($this.data('toggle') === 'on') {
        self.toggleOff($this);
      } else {
        self.toggleOn($this);
        if (options.onlyOneActive && self.options.selectors.length > 1) {
          self.toggleOff(self._getOtherButtons($this));
        }
      }

      return false;
    });

  }

  /**
   * Get all other Buttons
   * @param {Object} [$elm] clicked Button
   */
   _getOtherButtons($elm) {
    let $otherButtons,
    count = 0;

    this.options.selectors.forEach((i) => {
      if (i !== `.${$elm.attr('class')}`) {
        count++;
        $otherButtons = (count === 1) ? $(i) : $otherButtons.add(i);
      }
    });

    return $otherButtons;

  }

  /**
   * Toggle on Button and set active class
   * @param {Object} [$elm] clicked Button
   */
   toggleOn($elm) {
    const self = this,
    options = self.options,
    elmClass = $elm.attr('class');

    $(document).trigger(elmClass + '-on');
    //$(document).scrollTop(0);

    // Set Data Info to Toggle On
    $elm.data('toggle', 'on');
    self.$html.addClass(elmClass + options.classSuffix);
  }

  /**
   * Toggle off Button and remove active class
   * @param {Object} [$elm] clicked Button
   */
   toggleOff($elm) {
    const self = this,
    options = self.options;

    $elm.each((index, value) => {
      const $this = $(value),
      elmClass = $this.attr('class');

      $(document).trigger(elmClass + '-off');
      //$(document).scrollTop(0);

      // Set Data Info to Toggle Off
      $this.data('toggle', 'off');
      self.$html.removeClass(elmClass + options.classSuffix);
    });
  }

}

export default Buttons;



// WEBPACK FOOTER //
// ./prod/layout/js/modules/buttons.js